/**
 * ⭐ ONE SHAPE FOR THE BOARD'S OPEN-ITEM CHIPS (F106, 2026-09-29)
 *
 * > Pete: *"make these the same coloring as the warnings though because that is
 * > basically what these two bubbles are - warning you that [there are] left open
 * > items on past date's"*.
 *
 * Possible no-shows, Possible no-departure and No WMS sit side by side in the board
 * header; three chips drawn three ways would read as three kinds of thing. ⛔ They
 * are one kind — a warning with a count — so they share this button and the
 * app's warning tone (`WARNING_CHIP`).
 */
import type { ReactNode } from 'react';
import { WARNING_CHIP } from '@/lib/utils';

export function OpenItemChip({ onClick, title, icon, children }: {
    onClick: () => void;
    title: string;
    icon: ReactNode;
    children: ReactNode;
}) {
    return (
        <button
            type="button"
            onClick={onClick}
            title={title}
            className={`inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full border px-2 py-0.5 text-[11px] font-medium ${WARNING_CHIP}`}
        >
            {icon}
            {children}
        </button>
    );
}
